var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"content"},[_c('p',{staticStyle:{"color":"red"}},[_vm._v("Trainee Name: "+_vm._s(_vm.traineePdf.name))])])])}
var staticRenderFns = []

export { render, staticRenderFns }